import { DataHeaderGroup } from '@spa/reporting';

import { ReportTableGroupedColumnInterface } from '..';

export class ReportTableGroupedColumn extends DataHeaderGroup {
    constructor(data: ReportTableGroupedColumnInterface) {
        super(data);
    }
}
